export const TEXTS = {
  SETTINGS: 'Настройки',
  REMOVE: 'Удалить',
  RETRY: 'Повторить загрузку',
  UPLOADING: 'Загружается...',
  ERROR: 'Ошибка загрузки',
};
